export default __webpack_public_path__ + "static/media/back_svg.2be0f425.svg";